module.exports = __webpack_public_path__ + "static/basket-0185037f08c344d77eb0a24d9f0ce2f6.svg";